import { Tooltip } from 'react-bootstrap'

import { DataTableProvider } from 'components/DataTable'
import FbButton from 'components/FbUI/FbButton'
import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { default as styled } from 'styled-components'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { IContactCompany } from '../../../models/contact_companies'
import { IColumnVisibility } from '../../DataTable/types'
import { DealsTableComponentV2 } from './DealsTableComponentV2'
import { DealsTableComponent } from './DealsTableComponent'
import { DealsTableBaseFilters } from './DealsTableTypes'

interface DealsTableProps {
  setTotalRowsCount?: (count: number) => void
  forCompany?: Partial<IContactCompany>
  forDoorProxyId?: number
  showCompanyColumn?: boolean
  enablePagination?: boolean
  disableUrlPagination?: boolean
  baseFilters?: DealsTableBaseFilters
  tableKey: string
  filterIdentifierModifier?: string
}

export function DealsTable(
  props: DealsTableProps & {
    defaultColumnVisibility?: IColumnVisibility<unknown>
    useReports?: boolean
  }
) {
  const { tableKey, defaultColumnVisibility, useReports, ...rest } = props
  const { dealDetailPage, isLoading } = useFeatureFlagService()
  const enabledReportDeals = false

  // Use a separate column store key when dealDetailPage is on because
  // the column layout is fundamentally different (combined deal column
  // replaces separate identifier + deal_name columns).
  const columnsStoreKey = dealDetailPage ? 'DEALS_TABLE_V2' : 'DEALS_TABLE'

  if (isLoading) {
    return null
  }

  if (enabledReportDeals && useReports) {
    const currentTableKey = 'report-' + tableKey

    return (
      <ColumnsStoreProvider
        tableKey={columnsStoreKey}
        savedPresetsIdentifier={columnsStoreKey}
        defaultColumnVisibility={defaultColumnVisibility}
        preferredGroupOrder={[
          'Company Attributes',
          'Campaigns and Deals',
          'Forecast',
        ]}
      >
        <DataTableProvider tableKey={currentTableKey}>
          <DealsTableComponentV2 tableKey={currentTableKey} {...rest} />
        </DataTableProvider>
      </ColumnsStoreProvider>
    )
  }

  return (
    <ColumnsStoreProvider
      tableKey={columnsStoreKey}
      savedPresetsIdentifier={columnsStoreKey}
      defaultColumnVisibility={defaultColumnVisibility}
      preferredGroupOrder={[
        'Company Attributes',
        'Campaigns and Deals',
        'Forecast',
      ]}
    >
      <DataTableProvider tableKey={tableKey}>
        <DealsTableComponent tableKey={tableKey} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}

export const ExportButton = styled(FbButton)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 14px;

  gap: 8px;

  height: 44px;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`

export const tooltip = (
  <Tooltip id="tooltip">Download limited to 10,000 rows</Tooltip>
)

export const PAGE_SIZE = 100
